import { useHistory, useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useAnalyticsContext } from '../../../../../contexts/analytics/useAnalyticsContext';
import { MatchFilterId } from '../../../../../pages/match-page/match.page.enum';
import { THEME } from '../../../../../themes';
import { AppRouting } from '../../../../../services/appRoutingResolver';
import { FilledButton } from '../../../../../components/Common/Buttons/filled-button/filled-button.component';
import { ANALYTICS_EVENTS, EVENT_GROUP, PRODUCT_AREA } from '../../../../../consts/analytics';
import STRING_KEYS from '../../../../../language/keys';
import { PAGE_NAMES } from '../../../../../consts/pages';
import AvatarsList from '../../../../../components/Common/AvatarsList';
import {
  Card, Description, FooterContainer, HorizontalDivider, IconWrapper, EngageOrDeclineIcon, LockIcon, Title,
} from './engage-or-decline-card.styled';

const EngageOrDeclineCard = ({ icons }: EngageOrDeclineCardProps):JSX.Element => {
  const { t: translate } = useTranslation();
  const browserHistory = useHistory();
  const { positionId } = useParams<MatchUrlParams>();
  const { analyticsTrackEvent } = useAnalyticsContext();

  useEffect(() => {
    const payload = {
      eventName: ANALYTICS_EVENTS.GIVE_FEEDBACK_COMPONENT_VIEWED,
      eventGroup: EVENT_GROUP.IMP,
      pageName: PAGE_NAMES.MATCH_LIMIT,
      productArea: PRODUCT_AREA.MATCH_PAGE,
      pagePositionId: positionId,
    };
    analyticsTrackEvent(payload);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onClickGoToMatches = () => {
    const eventData = {
      eventName: ANALYTICS_EVENTS.CLICKED_ON_GIVE_FEEDBACK,
      eventGroup: EVENT_GROUP.CLICK,
      pageName: PAGE_NAMES.MATCH_LIMIT,
      productArea: PRODUCT_AREA.MATCH_PAGE,
      pagePositionId: positionId,
    };

    analyticsTrackEvent(eventData);
    browserHistory.push(
      AppRouting.buildMatchesPageUrl(positionId, MatchFilterId.TO_REVIEW.toString()),
    );
  };

  return (
    <Card>
      <HorizontalDivider />
      <IconWrapper>
        <LockIcon />
      </IconWrapper>
      <Title>{ translate(STRING_KEYS.DAILY_LIMIT.FREE_USER.ENGAGE_OR_DECLINE_CARD.TITLE) }</Title>
      <Description>
        { translate(STRING_KEYS.DAILY_LIMIT.FREE_USER.ENGAGE_OR_DECLINE_CARD.DESCRIPTION) }
      </Description>
      <FooterContainer>
        <AvatarsList
          icons={ icons }
        />
        <FilledButton
          buttonText={ translate(STRING_KEYS.DAILY_LIMIT.FREE_USER.ENGAGE_OR_DECLINE_CARD.BUTTON_TITLE) }
          onClick={ onClickGoToMatches }
          Icon={ EngageOrDeclineIcon }
          style={ {
            textColor: THEME.COLORS.PRIMARY_DARK,
            backgroundColor: THEME.COLORS.WARNING,
            activeBackgroundColor: THEME.COLORS_RGB.YELLOW_024,
            hoveredBackgroundColor: THEME.COLORS_RGB.YELLOW_064,
            uppercase: true,
          } }
        />
      </FooterContainer>
    </Card>
  );
};

export default EngageOrDeclineCard;
